/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Library imports */
import React, {Component, Fragment} from "react";
import PropTypes from 'prop-types';

/* Style imports */
import "./styles.css"

/*** End Imports ***/

  class BtnOutline extends Component {

    constructor(props) {
        super(props);
        this.state = {
            test: 0
        };
        
    };

    componentWillMount() {
        
    }

    componentDidMount() {

        
        
    }

    onClick = (e) => {
        e.preventDefault();
        e.target.blur();
        this.props.onClick();
        return false;
    };

    

    

    
    render() {
        
        return (
            <Fragment >
                <button
                    id = {this.props.id}
                    className = "btn-outline-gen"
                    onClick = {this.onClick}
                    style = {this.props.customStyle}
                    disabled = {this.props.isDisabled}
                    tabIndex = {this.props.tabIndex}
                >
                    {this.props.icon}
                    {this.props.title}
                </button>
            
            </Fragment>
        );
    }  
};

BtnOutline.propTypes = {
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    customStyle : PropTypes.object,
    isDisabled: PropTypes.bool
};

BtnOutline.defaultProps = {
    customStyle : {
        width : '100%'
    }
};
export default BtnOutline;


// WEBPACK FOOTER //
// ./src/components/Buttons/BtnOutline/BtnOutline.js